import {
  useCompanyReadDataContext,
  usePersonReadDataContext,
} from '@aibees/elephant/context';
import { useMemo } from 'react';
import { SearchType } from '../../types';
import { useActionSearchType } from '../use-action-search-type';

export function useOwnerData(searchType?: SearchType) {
  const { isPeople } = useActionSearchType(searchType);
  const { api: companyData } = useCompanyReadDataContext();
  const { api: personData } = usePersonReadDataContext();

  return useMemo(() => {
    const data = isPeople ? personData?.data : companyData?.data;
    return data?.user;
  }, [isPeople, personData?.data, companyData?.data]);
}
